var render = function () {
  var _vm$list;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return (_vm$list = _vm.list) !== null && _vm$list !== void 0 && _vm$list.length ? _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tabs__desktop"
  }, _vm._l(_vm.list, function (el, i) {
    return _c('div', {
      key: i,
      staticClass: "tabs__tab",
      class: {
        tabs__tab_active: el.value === _vm.modelValue
      },
      on: {
        "click": function ($event) {
          return _vm.emit('update:model-value', Object.assign({}, el, {
            index: i
          }));
        }
      }
    }, [_c('div', {
      staticClass: "tabs__tab-text"
    }, [_vm._v("\n        " + _vm._s(el.name) + "\n      ")]), _vm._v(" "), el.subtext ? _c('div', {
      staticClass: "tabs__subtext fz-12 lh-14 mt-2 grey-text"
    }, [_vm._v("\n        " + _vm._s(el.subtext) + "\n      ")]) : _vm._e()]);
  }), 0)]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }